import React from 'react'

const ChipCloud = ({ title, icon: Icon, items = [], hrefBuilder, getLabel = (i) => i, getKey = (i) => i }) => {
  return (
      <div className="rounded-lg border border-gray-200 bg-white p-4">
        <div className="mb-3 flex items-center gap-2">
            <Icon size={15} className="text-gray-400" />
            <h3 className="text-[13px] font-semibold text-gray-900">{title}</h3>
        </div>
        {items.length === 0 ? (
            <p className="text-[12px] text-gray-400">Nothing to show yet.</p>
        ) : (
            <div className="flex max-h-40 flex-wrap gap-1.5 overflow-y-auto pr-1">
                {items.map((item) => (
                    <a
                        key={getKey(item)}
                        href={hrefBuilder(item)}
                        className="rounded-full border border-gray-200 px-2.5 py-1 text-[11.5px] font-medium text-gray-600 transition hover:border-brand-300 hover:bg-brand-50 hover:text-brand-700"
                    >
                        {getLabel(item)}
                    </a>
                ))}
            </div>
        )}
    </div>
  )
}

export default ChipCloud